// eslint-disable-next-line import/no-extraneous-dependencies
import packageJson from '../../../../package.json';

export const packageName: string = packageJson.name;
export const packageVersion: string = packageJson.version;
